import React, { useEffect, useMemo, useState } from 'react'
import PropTypes from 'prop-types'
import i18n from 'simple-react-i18n'
import Input from '../../../../components/forms/Input'
import { orderBy } from 'lodash'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import Icon from '../../../../components/icon/Icon'
import { arrayOf } from '../../../../utils/StoreUtils'
import { SANDRE } from '../../../../referencial/constants/ReferencialConstants'
import InstallationAction from '../../../actions/InstallationAction'
import Checkbox from '../../../../components/forms/Checkbox'
import NumberField from '../../../../components/forms/NumberField'
import SieauParameterDto from '../../../../administration/dto/SieauParameterDto'
import {
    getVisitCheckBoxChange,
    getVisitSandreSelectChange,
    getVisitSelectChange,
    getVisitSimpleDatePickerChange,
} from '../../../../utils/VisitUtils'
import DtoManagementUnit from '../../../../referencial/components/managementUnit/dto/DtoManagementUnit'
import Select from '../../../../components/forms/Select'
import SimpleDatePicker from '../../../../components/forms/SimpleDatePicker'
import { INSTALLATION_TYPE } from '../../../constants/InstallationConstants'
import ManagementUnitAction from 'referencial/components/managementUnit/actions/ManagementUnitAction'
import DtoSector from 'referencial/components/sector/dto/DtoSector'
import { Button, Dialog, DialogActions, DialogContent, Grid2 } from '@mui/material'
import { DefaultDialogTitle } from 'components/styled/Dialog'
import useSandreList from 'utils/customHook/useSandreList'
import { hasValue } from 'utils/NumberUtil'
import { isDisplayed } from 'utils/InstallationUtils'
import SimpleTextArea from 'components/forms/SimpleTextArea'

const styleLabelSelect = {
    fontSize: '13px',
}

const InstallationInfosPanel = ({
    onChange = () => { },
    onChangeVisit = () => { },
    station = {},
    disabled = false,
    readMode = false,
    newPoint = false,
    noEditCode = false,
}) => {
    const dispatch = useDispatch()

    const {
        sandreCodes,
        managementUnits,
        applicationSettings,
        sectors,
    } = useSelector(store => ({
        sandreCodes: store.ReferencialReducer.sandreCodes,
        managementUnits: store.ManagementUnitReducer.managementUnits,
        applicationSettings: store.AdministrationReducer.applicationSettings,
        sectors: store.SectorReducer.sectors,
    }), shallowEqual)

    const managementUnitsFormatted = useMemo(() => orderBy(managementUnits.map(mu => ({
        ...mu,
        parentOrder: hasValue(mu.parent) ? (managementUnits.find((m) => m.managementCode === mu.parent) || {}).id : '',
        idForOrder: mu.parent || mu.managementCode,
    })), ['idForOrder', 'parentOrder', 'id']), [managementUnits])

    const [newCode, setNewCode] = useState()
    const [open, setOpen] = useState()

    const states = useSandreList(SANDRE.CODE_ETAT)

    useEffect(() => {
        if (!managementUnits.length) {
            dispatch(ManagementUnitAction.fetchManagementUnits())
        }
    }, [])

    const onSaveBssCode = () => {
        dispatch(InstallationAction.changeBssCode({ ...station, code: newCode, fromCode: station.code, toCode: newCode }, () => {
            setOpen(false)
            onChange({ code: newCode })
        }))
    }

    return (
        <Grid2 container columnSpacing={1}>
            <Grid2 size={(readMode || noEditCode) ? 6 : 5}>
                <Input
                    value={station.code}
                    title={i18n.code}
                    disabled={!newPoint}
                    onChange={v => {
                        onChange({ code: v })
                    }}
                    readMode={readMode}
                    className='no-padding-right'
                />
            </Grid2>
            {!readMode && <Grid2 size={1} sx={noEditCode ? { display: 'none' } : {}} container alignItems='center'><Icon icon='edit' onClick={() => setOpen(true)} /></Grid2>}
            <Grid2 size={6}>
                <NumberField
                    value={station.id}
                    title={i18n.internalIdentifier}
                    readMode={readMode}
                    disabled={!readMode}
                />
            </Grid2>
            <Grid2 size={6}>
                <Input
                    value={station.name}
                    title={i18n.name}
                    onChange={v => {
                        onChange({ name: v })
                        onChangeVisit({ previousValue: station.name, newValue: v, field: i18n.name })
                    }}
                    disabled={disabled}
                    readMode={readMode}
                />
            </Grid2>
            <Grid2 size={6}>
                <Input
                    value={station.mnemonic}
                    title={i18n.mnemonic}
                    onChange={v => {
                        onChange({ mnemonic: v })
                        onChangeVisit({ previousValue: station.mnemonic, newValue: v, field: i18n.mnemonic })
                    }}
                    disabled={disabled}
                    readMode={readMode}
                />
            </Grid2>
            <Grid2 size={6}>
                <SimpleDatePicker
                    id='creationDate'
                    style={{ padding: 0 }}
                    label={i18n.creationDate}
                    value={station.creationDate}
                    onChange={v => {
                        onChange({ creationDate: v })
                        onChangeVisit(getVisitSimpleDatePickerChange(i18n.creationDate, station.creationDate, v))
                    }}
                    disabled={disabled}
                    readMode={readMode}
                />
            </Grid2>
            <Grid2 size={6}>
                <SimpleDatePicker
                    id='decommissioningDate'
                    style={{ padding: 0 }}
                    label={i18n.decommissioningDate}
                    value={station.endDate}
                    onChange={v => {
                        onChange({ endDate: v })
                        onChangeVisit(getVisitSimpleDatePickerChange(i18n.decommissioningDate, station.endDate, v))
                    }}
                    disabled={disabled}
                    readMode={readMode}
                />
            </Grid2>
            {station.installationType !== INSTALLATION_TYPE.STEP && (
                <>
                    <Grid2 size={6}>
                        <Select
                            styleLabel={{ ...styleLabelSelect }}
                            value={station.managementCode}
                            label={i18n.managementUnit}
                            options={managementUnitsFormatted.filter((u) => !u.parent)}
                            onChange={v => {
                                onChange({ managementCode: v, subManagementCode: null })
                                // onChangeVisit(getVisitSelectChange(managementUnits, 'subManagementCode', i18n.subManagementUnit, station.subManagementCode, null))
                                onChangeVisit(getVisitSelectChange(managementUnits, 'managementCode', i18n.managementUnit, station.managementCode, v))
                            }}
                            keyValue='managementCode'
                            keyLabel='labelWithCode'
                            integerValue
                            disabled={disabled}
                            readMode={readMode}
                            noSort
                        />
                    </Grid2>
                    <Grid2 size={6}>
                        <Select
                            styleLabel={{ ...styleLabelSelect }}
                            value={station.subManagementCode}
                            label={i18n.subManagementUnit}
                            options={managementUnitsFormatted.filter((u) => u.parent && u.parent === station.managementCode)}
                            onChange={v => {
                                onChange({ subManagementCode: v })
                                onChangeVisit(getVisitSelectChange(managementUnits, 'subManagementCode', i18n.subManagementUnit, station.subManagementCode, v))
                            }}
                            keyValue='managementCode'
                            keyLabel='labelWithCode'
                            integerValue
                            disabled={disabled}
                            readMode={readMode}
                            noSort
                        />
                    </Grid2>
                </>
            )}
            <Grid2 size={6}>
                <Select
                    styleLabel={{ ...styleLabelSelect }}
                    value={station.stateCode}
                    label={i18n.state}
                    options={states}
                    onChange={v => {
                        onChange({ stateCode: v })
                        onChangeVisit(getVisitSandreSelectChange(sandreCodes, SANDRE.CODE_ETAT, i18n.state, station.stateCode, v))
                    }}
                    keyvalue='code'
                    integerValue
                    disabled={disabled}
                    readMode={readMode}
                    data-cy='state'
                />
            </Grid2>
            <Grid2 size={6} container alignItems='center'>
                <Checkbox
                    checked={station.exploitationCode === 1}
                    label={i18n.exploitation}
                    onChange={v => {
                        onChange({ exploitationCode: v ? 1 : 0 })
                        onChangeVisit(getVisitCheckBoxChange(i18n.exploitation, station.exploitationCode, v))
                    }}
                    disabled={readMode || disabled}
                />
            </Grid2>
            {[
                INSTALLATION_TYPE.BOREHOLE,
                INSTALLATION_TYPE.STEP,
                INSTALLATION_TYPE.CAPTURE,
                INSTALLATION_TYPE.LIFTING_STATION,
                INSTALLATION_TYPE.PUMPING,
                INSTALLATION_TYPE.TREATMENT,
                INSTALLATION_TYPE.TANK,
                INSTALLATION_TYPE.AEP_PRODUCTION,
                INSTALLATION_TYPE.AEP_DISINFECTION,
                INSTALLATION_TYPE.AEP_OVERPRESSURE,
                INSTALLATION_TYPE.SECTOR_COUNT,
            ].includes(station.installationType) && (
                <>
                    <Grid2 size={6}>
                        <Select
                            styleLabel={{ ...styleLabelSelect }}
                            value={station.sectorId}
                            label={i18n.sector}
                            options={sectors}
                            onChange={v => {
                                onChange({ sectorId: v })
                                onChangeVisit(getVisitSelectChange(sectors, 'sectorId', i18n.sector, station.sectorId, v))
                            }}
                            disabled={disabled}
                            readMode={readMode}
                        />
                    </Grid2>
                    <Grid2 size={6}>
                        <Checkbox
                            checked={station.floodZone}
                            label={i18n.floodZone}
                            onChange={v => {
                                onChange({ floodZone: v })
                                onChangeVisit(getVisitCheckBoxChange(i18n.floodZone, station.floodZone, v))
                            }}
                            disabled={readMode}
                        />
                    </Grid2>
                </>
            )}
            {[
                INSTALLATION_TYPE.BOREHOLE,
                INSTALLATION_TYPE.LIFTING_STATION,
                INSTALLATION_TYPE.PUMPING,
                INSTALLATION_TYPE.TREATMENT,
            ].includes(station.installationType) && (
                <Grid2 size={6}>
                    <SimpleDatePicker
                        id='effectiveReceiptDate'
                        label={i18n.effectiveReceiptDate}
                        value={station.effectiveReceiptDate}
                        style={{ padding: 0 }}
                        onChange={v => {
                            onChange({ effectiveReceiptDate: v })
                            onChangeVisit(getVisitSimpleDatePickerChange(i18n.effectiveReceiptDate, station.effectiveReceiptDate, v))
                        }}
                        disabled={disabled}
                        readMode={readMode}
                    />
                </Grid2>
            )}
            {[INSTALLATION_TYPE.BOREHOLE,
                INSTALLATION_TYPE.TANK,
                INSTALLATION_TYPE.PUMPING,
                INSTALLATION_TYPE.TREATMENT].includes(station.installationType) && (
                <Grid2 size={6}>
                    <SimpleDatePicker
                        id='prodDate'
                        label={i18n.prodDate}
                        value={station.prodDate}
                        style={{ padding: 0 }}
                        onChange={v => {
                            onChange({ prodDate: v })
                            onChangeVisit(getVisitSimpleDatePickerChange(i18n.prodDate, station.prodDate, v))
                        }}
                        disabled={disabled}
                        readMode={readMode}
                    />
                </Grid2>
            )}
            <Grid2 size={12}>
                <SimpleTextArea
                    value={station.descriptive}
                    title={i18n.descriptive}
                    onChange={v => {
                        onChange({ descriptive: v })
                        onChangeVisit({ previousValue: station.descriptive, newValue: v, field: i18n.descriptive })
                    }}
                    disabled={disabled}
                    readMode={readMode}
                />
            </Grid2>
            <Grid2 size={12}>
                <SimpleTextArea
                    value={station.comments}
                    title={i18n.comment}
                    onChange={v => {
                        onChange({ comments: v })
                        onChangeVisit({ previousValue: station.comments, newValue: v, field: i18n.comment })
                    }}
                    disabled={disabled}
                    readMode={readMode}
                />
            </Grid2>
            {isDisplayed(applicationSettings, 'INFOS_COMPL', station.installationType) && (
                <Grid2 size={6}>
                    <Input
                        value={station.declarationNumber}
                        title={i18n.declarationNumber}
                        onChange={v => {
                            onChange({ declarationNumber: v })
                            onChangeVisit({ previousValue: station.declarationNumber, newValue: v, field: i18n.declarationNumber })
                        }}
                        disabled={disabled}
                        readMode={readMode}
                    />
                </Grid2>
            )}
            <Dialog
                fullWidth
                maxWidth='xs'
                open={open}
            >
                <DefaultDialogTitle
                    title={i18n.changeCode}
                    onClose={() => setOpen(false)}
                />
                <DialogContent>
                    <Input
                        col={5}
                        title={i18n.code}
                        onChange={setNewCode}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={onSaveBssCode} variant='contained' color='primary'>
                        {i18n.validate}
                    </Button>
                </DialogActions>
            </Dialog>
        </Grid2>
    )
}

InstallationInfosPanel.propTypes = {
    station: PropTypes.object, // DtoInstallation
    disabled: PropTypes.bool,
    readMode: PropTypes.bool,
    onChange: PropTypes.func,
    onChangeVisit: PropTypes.func,
    managementUnits: arrayOf(DtoManagementUnit),
    applicationSettings: arrayOf(SieauParameterDto),
    sectors: arrayOf(DtoSector),
    newPoint: PropTypes.bool,
    noEditCode: PropTypes.bool,
}

export default InstallationInfosPanel
